import { render, staticRenderFns } from "./CabeceraModal.vue?vue&type=template&id=a01410a4&scoped=true&"
import script from "./CabeceraModal.vue?vue&type=script&lang=ts&"
export * from "./CabeceraModal.vue?vue&type=script&lang=ts&"
import style0 from "./CabeceraModal.vue?vue&type=style&index=0&id=a01410a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01410a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a01410a4', component.options)
    } else {
      api.reload('a01410a4', component.options)
    }
    module.hot.accept("./CabeceraModal.vue?vue&type=template&id=a01410a4&scoped=true&", function () {
      api.rerender('a01410a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Modal/CabeceraModal.vue"
export default component.exports